import './dialog-title-bar.scss';

import * as gzDialogTitleBar from './dialog-title-bar.directive';
import gazelleCore from 'gazelle/src/core/core.module';

export default angular.module('gazelle.components.dialogTitleBar', [
  'pascalprecht.translate',
  'ngMaterial',
  gazelleCore,
])
  .directive(gzDialogTitleBar.name, gzDialogTitleBar.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/dialog-title-bar/dialog-title-bar.module.js